import ZusDeclarationPackageApi from '../../../../../api-v2/bookkeeping/zus-declarations-package.js';
import action from '../../../abstract/action.js';

export default action({
  label: 'Pobierz KEDU',
  icon: 'PrinterIcon',
  main: () => false,
  handle: async ({ item: { id } }) => await ZusDeclarationPackageApi.downloadKedu({ zuspackageId: id }).then(response => {
    let disposition = response.headers['content-disposition'];
    let filename = 'zestaw.xml';
    if (disposition && disposition.indexOf('attachment') !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    let blob = new Blob([response.data]);
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 250);
  }),
});